
  import ipxStaticRuntime$qY71wphh_hfjuFgV74KiOlka0ySSt0jFvNyyTjspfgs from '/Users/enricoreinsdorf/Projekte/RE-Design/KI Website/website/node_modules/@nuxt/image/dist/runtime/providers/ipxStatic'
  
  export const imageOptions = {
    ...{
  "screens": {
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "2xl": 1536,
    "xs": 320,
    "xxl": 1536
  },
  "presets": {},
  "provider": "ipxStatic",
  "domains": [
    "re-design.de",
    "www.re-design.de"
  ],
  "alias": {
    "/unsplash": "https://images.unsplash.com"
  },
  "densities": [
    1,
    2
  ],
  "format": [
    "webp",
    "jpg",
    "png",
    "webp"
  ],
  "quality": 85
},
    /** @type {"ipxStatic"} */
    provider: "ipxStatic",
    providers: {
        ['ipxStatic']: { setup: ipxStaticRuntime$qY71wphh_hfjuFgV74KiOlka0ySSt0jFvNyyTjspfgs, defaults: {} }
    }
  }
